import { render, staticRenderFns } from "./Datawallets.vue?vue&type=template&id=fe26914a&"
import script from "./Datawallets.vue?vue&type=script&lang=js&"
export * from "./Datawallets.vue?vue&type=script&lang=js&"
import style0 from "./Datawallets.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe26914a')) {
      api.createRecord('fe26914a', component.options)
    } else {
      api.reload('fe26914a', component.options)
    }
    module.hot.accept("./Datawallets.vue?vue&type=template&id=fe26914a&", function () {
      api.rerender('fe26914a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ddv-home/Datawallets.vue"
export default component.exports